import { X, Clock, CheckCircle, XCircle, AlertTriangle } from "lucide-react";
import { timeAgo } from "../../utilis/Time";

const STATUS_CONFIG = {
  pending:  { label: "Pending",  Icon: Clock,         color: "bg-amber-100 text-amber-700 border-amber-200"  },
  approved: { label: "Approved", Icon: CheckCircle,   color: "bg-green-100 text-green-700 border-green-200"  },
  rejected: { label: "Rejected", Icon: XCircle,       color: "bg-red-100   text-red-700   border-red-200"    },
  deleted:  { label: "Deleted",  Icon: AlertTriangle, color: "bg-gray-100  text-gray-500  border-gray-200"   },
};

const getSubmissionQuestTitle = (submission) => {
  if (submission?.challenge?.title) return submission.challenge.title;
  if (submission?.challengeTitle) return submission.challengeTitle;
  if (submission?.gallery?.title) return submission.gallery.title;
  return "General quest submission";
};

const Viewsubmission = ({ isOpen, onClose, submission }) => {
  if (!isOpen || !submission) return null;

  const cfg = STATUS_CONFIG[submission.status] || STATUS_CONFIG.pending;
  const { Icon } = cfg;
  const memberDisplayName =
    submission?.user?.preferredName ||
    [submission?.user?.firstName, submission?.user?.lastName].filter(Boolean).join(" ").trim() ||
    submission?.user?.memberId ||
    "Unknown";

  return (
    <div onClick={onClose} className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div onClick={(e) => e.stopPropagation()}
        className="bg-white rounded-2xl w-full max-w-lg max-h-[90vh] overflow-y-auto shadow-2xl">

        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100">
          <div className="flex items-center gap-3">
            {submission?.user?.pfp ? (
              <img src={submission.user.pfp} alt={memberDisplayName}
                className="w-9 h-9 rounded-full object-cover border border-gray-100" />
            ) : (
              <div className="w-9 h-9 rounded-full bg-cyan-100 flex items-center justify-center">
                <span className="font-cinzel font-bold text-cyan-600 text-sm">
                  {(memberDisplayName || "?").charAt(0).toUpperCase()}
                </span>
              </div>
            )}
            <div>
              <p className="font-outfit font-semibold text-gray-900 text-sm">
                {memberDisplayName}
              </p>
              <p className="font-outfit text-xs text-gray-400">{timeAgo(submission.createdAt)}</p>
            </div>
          </div>
          <button onClick={onClose}
            className="w-8 h-8 rounded-lg hover:bg-gray-100 flex items-center justify-center transition-colors">
            <X size={18} className="text-gray-500" />
          </button>
        </div>

        <div className="p-6 space-y-5">

          {/* Status */}
          <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold border font-outfit ${cfg.color}`}>
            <Icon size={12} strokeWidth={2.5} />
            {cfg.label}
          </span>

          {/* Image */}
          {submission.image && (
            <div className="rounded-2xl overflow-hidden border border-gray-100">
              <img src={submission.image} alt={submission.title}
                className="w-full h-56 object-cover" />
            </div>
          )}

          {/* Title */}
          <div>
            <p className="font-outfit text-xs font-semibold uppercase tracking-wider text-gray-400 mb-1">Title</p>
            <h3 className="font-cinzel text-xl font-bold text-gray-900">{submission.title}</h3>
          </div>

          {/* Quest */}
          <div>
            <p className="font-outfit text-xs font-semibold uppercase tracking-wider text-gray-400 mb-1">Quest / Event</p>
            <p className="font-outfit text-sm font-semibold text-gray-800">{getSubmissionQuestTitle(submission)}</p>
            {(submission.challenge?.category || submission.challengeCategory) && (
              <p className="font-outfit text-xs text-gray-400 mt-0.5 capitalize">
                {submission.challenge?.category || submission.challengeCategory}
              </p>
            )}
          </div>

          {/* Description */}
          {submission.description && (
            <div>
              <p className="font-outfit text-xs font-semibold uppercase tracking-wider text-gray-400 mb-1">Description</p>
              <p className="font-outfit text-sm text-gray-700 leading-relaxed">{submission.description}</p>
            </div>
          )}

          {/* Member Bio */}
          {submission.member_bio && (
            <div>
              <p className="font-outfit text-xs font-semibold uppercase tracking-wider text-gray-400 mb-1">Member Bio</p>
              <p className="font-outfit text-sm text-gray-700">{submission.member_bio}</p>
            </div>
          )}

          {/* Close button */}
          <button onClick={onClose}
            className="w-full py-2.5 rounded-full border border-gray-200 text-gray-600 font-outfit text-sm font-medium hover:bg-gray-50 transition-colors mt-2">
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default Viewsubmission;
